import { DateTime } from 'luxon';

export const millisecondsPerSecond = 1000;
export const secondsPerMinute = 60;
export const minutesPerHour = 60;
export const hoursPerDay = 24;
export const daysPerWeek = 7;

export const millisecondsPerMinute = millisecondsPerSecond * secondsPerMinute;
export const millisecondsPerHour = millisecondsPerMinute * minutesPerHour;
export const millisecondsPerDay = millisecondsPerHour * hoursPerDay;
export const millisecondsPerWeek = millisecondsPerDay * daysPerWeek;

export function formatDate(
  date: string | DateTime | undefined | null,
  formatOpts?: Intl.DateTimeFormatOptions,
  invalidDatePlaceholder: string = 'Invalid Date',
): string {
  date = typeof date === 'string' ? DateTime.fromISO(date) : date;

  return date?.isValid ? date.toLocaleString(formatOpts) : invalidDatePlaceholder;
}
